import { AppThunk } from "@Store/index";
import {
  fetchAmberPlusCrossPageDataIfNeeded,
  setAmberPlusCrossMeta,
  fetchLeadBannerData,
  fetchStandardKitData,
} from "./amberPlusCrossReducer";

const loadData = (props: any): AppThunk[] => {
  const thunks: AppThunk[] = [
    fetchAmberPlusCrossPageDataIfNeeded(),
    setAmberPlusCrossMeta(props?.params?.service, props?.req?.url),
    fetchStandardKitData(),
  ];

  const leadUuid = props?.req?.query?.lead_uuid;
  if (leadUuid) {
    thunks.push(fetchLeadBannerData(leadUuid));
  }

  return thunks;
};

export default loadData;
